"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getModelDataByVersion = void 0;
var _paulCorePackage = require("paul-core-package");
var _models = require("../components/models");
var _EmptyModel = require("../components/Viewer/Models/EmptyModel");
const {
  modelsWithVersion
} = _paulCorePackage.constants;
const modelsByVersion = {
  [modelsWithVersion.smartValve_v1_v2_v3]: _models.SmartValveModel,
  [modelsWithVersion.smartValve_v4_v5]: _models.SmartValveModel,
  [modelsWithVersion.smartValve_v6]: _models.SmartValveV6Model,
  [modelsWithVersion.temperatureSensor]: _models.SensorModel,
  [modelsWithVersion.paulTemperature_v1]: _models.DoubleTemperatureSensorModel,
  [modelsWithVersion.energyValve]: _models.EnergyValveModel,
  [modelsWithVersion.pump]: _models.CirculationPumpModel,
  [modelsWithVersion.mixerValve]: _models.MixerModel
};
const getModeByVersion = deviceClassificationVersion => {
  const model = modelsByVersion[deviceClassificationVersion];
  if (!model && deviceClassificationVersion) {
    return _EmptyModel.EmptyModel;
  }
  return model;
};
const getModelDataByVersion = thingProductDisplayClassification => {
  const deviceClassificationVersion = _paulCorePackage.functions.getDisplayClassificationVersion(thingProductDisplayClassification);
  return {
    version: deviceClassificationVersion,
    model: getModeByVersion(deviceClassificationVersion)
  };
};
exports.getModelDataByVersion = getModelDataByVersion;